// Central registry — adding a future template is a 2-line change:
//   1. Import the new component
//   2. Add it to the TEMPLATE_REGISTRY map
import Traditional from "./Traditional";
import ComingSoon from "./ComingSoon";

export const TEMPLATE_REGISTRY = {
  traditional: { component: Traditional, available: true },
  contemporary: { component: ComingSoon, available: false },
  outreach: { component: ComingSoon, available: false },
};

export function getTemplate(id) {
  return TEMPLATE_REGISTRY[id] || TEMPLATE_REGISTRY.traditional;
}
